<template>
  <k-page>
    <k-navbar title="Not found" back-link="Back"></k-navbar>
    <k-block strong inset>
      <p>Sorry</p>
      <p>Requested content not found.</p>
    </k-block>
  </k-page>
</template>
<script>
export default {};
</script>
